var _title;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAad = function SvgAad(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50.001,
    viewBox: "0 0 50 50.001"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "AAD color")), /*#__PURE__*/React.createElement("path", {
    d: "M26,51a4.575,4.575,0,0,1-3.261-1.352L2.351,29.26a4.61,4.61,0,0,1,0-6.521L22.74,2.351a4.609,4.609,0,0,1,6.522,0L49.648,22.739a4.609,4.609,0,0,1,0,6.523L29.262,49.648A4.578,4.578,0,0,1,26,51",
    transform: "translate(-1 -0.999)",
    style: {
      fill: "#59b4d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.614,22.092a3.9,3.9,0,0,0-3.265,6.052L28.6,35.888a4.55,4.55,0,0,0-.656-0.373V15.758a3.909,3.909,0,1,0-3.9,0V35.514a4.48,4.48,0,0,0-.632.353l-7.753-7.753a4.016,4.016,0,1,0-2.006,1.566l8.15,8.15a4.551,4.551,0,1,0,8.387.032l8.173-8.172a3.867,3.867,0,0,0,1.241.22A3.909,3.909,0,0,0,39.614,22.092Z",
    transform: "translate(-1 -0.999)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.007,
    y: 9.228,
    width: 2.523,
    height: 20.676,
    transform: "translate(-5.09 28.261) rotate(-45.008)",
    style: {
      isolation: "isolate"
    },
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.409,
    y: 18.317,
    width: 20.677,
    height: 2.524,
    transform: "translate(-9.353 17.992) rotate(-45)",
    style: {
      isolation: "isolate"
    },
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.665,39.613a2.709,2.709,0,1,1-2.71-2.709,2.71,2.71,0,0,1,2.71,2.709",
    transform: "translate(-1 -0.999)",
    style: {
      fill: "#b8d432"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.174,12.388A2.174,2.174,0,1,1,26,10.214a2.174,2.174,0,0,1,2.174,2.174",
    transform: "translate(-1 -0.999)",
    style: {
      fill: "#b8d432"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.563,26a2.174,2.174,0,1,1-2.174-2.174A2.175,2.175,0,0,1,14.563,26",
    transform: "translate(-1 -0.999)",
    style: {
      fill: "#b8d432"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.788,26a2.174,2.174,0,1,1-2.175-2.174A2.175,2.175,0,0,1,41.788,26",
    transform: "translate(-1 -0.999)",
    style: {
      fill: "#b8d432"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.262,2.351a4.608,4.608,0,0,0-6.521,0L2.352,22.739a4.608,4.608,0,0,0,0,6.521L13.9,40.8,35.61,8.7Z",
    transform: "translate(-1 -0.999)",
    style: {
      isolation: "isolate"
    },
    opacity: 0.1
  }));
};
export default SvgAad;